import React from 'react';
import ReactDOM from 'react-dom';
import reduxThunk from 'redux-thunk';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import { initialize } from 'react-localize-redux';

import globalTranslations from "./assets/translations/common.json";
import operational from "./assets/translations/operational.json";
import engineering from "./assets/translations/engineering.json";
import technicals from "./assets/translations/technicals.json";
import context from './assets/translations/context.json';
import interfaceTrad from './assets/translations/interface.json';
import quaterlyTrad from './assets/translations/quaterly.json';
import implication from './assets/translations/implication.json';
import project from './assets/translations/project.json'

import App from './components/App';
import './css/stylesheets/base.css';
import './../node_modules/@fortawesome/fontawesome-free/css/all.css';
import './../node_modules/@fortawesome/fontawesome-free/js/all.js';

import reducers from './reducers/index';
import { AUTH_USER } from './actions/types'

const createStoreWithMiddleware = applyMiddleware(reduxThunk)(createStore);
const store = createStoreWithMiddleware(
  reducers,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

const onMissingTranslation = ({ defaultTranslation }) => {
  return ''
};
const languages = {
  languages: [
    { name: "English", code: "en" },
    { name: "French", code: "fr" },
    { name: "Spanish", code: "es" },
    { name: "German", code: "de" },
    { name: "Italian", code: "it" },
  ],
  translation: Object.assign({}, project, globalTranslations, operational, engineering, technicals, context, interfaceTrad, implication, quaterlyTrad),
  options: {
    renderToStaticMarkup: false,
    onMissingTranslation
  }
};


store.dispatch(initialize(languages));

const token = localStorage.getItem('token');

if (token) {
  // Update application state. User has token and is probably authenticated
  store.dispatch({ type: AUTH_USER });
}



ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);
